<template>
  <v-app-bar id="app-bar" absolute app color="transparent" flat height="75">
    <v-btn
      v-if="user"
      class="mr-3"
      elevation="1"
      fab
      small
      @click="toggleDrawer"
    >
      <v-icon> mdi-menu </v-icon>
    </v-btn>

    <v-toolbar-title
      class="hidden-sm-and-down font-weight-light"
      v-text="$route.name"
    />

    <v-spacer />

    <div class="mx-3" />

    <v-btn v-if="!user" class="ml-2" min-width="0" text to="/pages/login">
      Login
    </v-btn>

    <v-btn
      v-if="!user"
      class="ml-2"
      min-width="0"
      text
      outlined
      color="primary"
      to="/pages/signup"
    >
      Signup
    </v-btn>

    <base-theme-toggle
      v-if="user"
      :icon-only="true"
      class="ml-2"
    />

    <base-user-avatar
      v-if="user"
      :user="user"
      :size="40"
      :show-tooltip="true"
      class="ml-2"
    />

    <v-btn
      v-if="user"
      class="ml-2"
      min-width="0"
      text
      outlined
      color="primary"
      @click="logout"
    >
      Logout
    </v-btn>
  </v-app-bar>
</template>

<script>
// Utilities
import { mapState } from "vuex";
// Components are auto-registered by src/plugins/base.js as BaseUserAvatar and BaseThemeToggle

export default {
  name: "DashboardCoreAppBar",

  computed: {
    ...mapState({
      user: (state) => state.user.user,
    }),
  },

  methods: {
    toggleDrawer() {
      // Emit event to parent to toggle drawer
      this.$root.$emit('toggle-drawer');
    },
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/").catch(() => {});
      });
    },
  },
};
</script>
